import { useCallback, useEffect, useState } from "react";

import { CanvasCore } from "../lib/canvas";
import { KeybindManager } from "../lib/keybinds";
import { useModerator } from "./Moderator";

export const ModCanvasOverlay = () => {
  const [mode, setMode] = useState<"SELECT_POINT_1" | "SELECT_POINT_2">(
    "SELECT_POINT_1",
  );
  const { state, dispatch } = useModerator();

  const handleClick = useCallback(
    (e: { clientX: number; clientY: number }) => {
      const canvasPos = CanvasCore.get().screenToPos(e.clientX, e.clientY);
      if (mode === "SELECT_POINT_2") {
        dispatch({ action: "OPEN_MENU" });
      }
      dispatch({
        action: mode,
        x: canvasPos[0],
        y: canvasPos[1],
      });
      setMode((m) =>
        m === "SELECT_POINT_1" ? "SELECT_POINT_2" : "SELECT_POINT_1",
      );
    },
    [dispatch, mode],
  );

  const handleClear = useCallback(() => {
    dispatch({ action: "END_SELECT_AREA" });
  }, [dispatch]);

  useEffect(() => {
    KeybindManager.on("MOD_SELECT", handleClick);
    KeybindManager.on("DESELECT_COLOR", handleClear);

    return () => {
      KeybindManager.off("MOD_SELECT", handleClick);
      KeybindManager.off("DESELECT_COLOR", handleClear);
    };
  }, [handleClear, handleClick]);

  if (!state.selection?.selecting) return <></>;

  const point1 = [
    state.selection?.point1?.[0] || 0,
    state.selection?.point1?.[1] || 0,
  ];
  const point2 = [
    state.selection?.point2?.[0] || 0,
    state.selection?.point2?.[1] || 0,
  ];

  const width = point2[0] + 1 - point1[0];
  const height = point2[1] + 1 - point1[1];

  return (
    <div
      style={{
        backgroundColor: "#f00",
        position: "absolute",
        top: `${point1[1]}px`,
        left: `${point1[0]}px`,
        width: `${width}px`,
        height: `${height}px`,
      }}
      className="animate-pulse pointer-events-none"
    ></div>
  );
};
